import { useScratchTotal } from "api/useScratchTotal";
import faqlines from "assets/faqlines.svg";
import scratch from "assets/scratch.svg";
import React from "react";
import { Helmet } from "react-helmet";

const MegaScratch = () => {
  const { data } = useScratchTotal() || {};
  const sortedData = data?.sort((a, b) => b.prize - a.prize);
  return (
    <div className="relative bg-[#F5F7FA]  flex-grow">
      {/* Header */}
      <div className="flex bg-[#0048A6] mt-[93px] justify-center relative z-0 overflow-hidden h-[100px] items-center">
        <p className="font-bold text-4xl text-white text-center md:text-[32px]">
          MegaScratch
        </p>
        <img
          alt=""
          src={faqlines}
          className="object-cover absolute right-0 bottom-0 pointer-events-none z-0"
        />
      </div>

      <div className="flex flex-col items-center w-full py-10  relativ h-full  ">
        <div className="w-full max-w-[900px] grid grid-cols-3 text-center border-t border-gray-200 ">
          <div className="py-4 font-semibold text-lg text-gray-700 border-b  border-gray-200 pr-16">
            Үнийн дүн
          </div>
          <div className="py-4 font-semibold text-lg text-gray-700 border-b border-gray-200">
              Хонжворын тоо
          </div>
          <div className="py-4 font-semibold text-lg text-gray-700 border-b border-gray-200 pl-16">
            Азтан болсон
          </div>
          <div className={"w-full flex flex-col col-span-3 gap-4"}>
            {sortedData?.map((item, index) => (
              <div
                key={index}
                className={
                  "w-full grid grid-cols-3 text-center border-t border-gray-200 rounded-md gap-16"
                }
              >
                <div
                  className={`${
                    index % 2 === 0 ? "bg-black0 shadow-lg" : "bg-transparent"
                  } py-3 text-[18px] text-black00  font-medium border-b border-gray-100 rounded-[5px] text-start  pl-16 `}
                >
                  ₮{item.prize?.toLocaleString()}
                </div>
                <div
                  className={`${
                    index % 2 === 0 ? "bg-black0 shadow-lg" : "bg-transparent"
                  } py-3 text-[18px] text-black00  font-medium border-b border-gray-100 rounded-[5px] text-center `}
                >
                  {item.total_count}
                </div>
                <div
                  className={`${
                    index % 2 === 0 ? "bg-black0 shadow-lg" : "bg-transparent"
                  } py-3 text-[18px] text-black00  font-medium border-b border-gray-100 rounded-[5px] text-center  `}
                >
                  {item.scanned_count ?? "—"}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <img
        src={scratch}
        alt="scratch"
        className="absolute h-full w-full z-0 left-[-600px] bottom-0 "
      />
    </div>
  );
};

export default MegaScratch;
